




import Vue from 'vue';
import Projects from '@/containers/projects';

export default Vue.extend({
  components: {
    Projects,
  },

  mounted() {
    this.$store.dispatch('projects/fetch:all');
  },
});
